/*  jQuery Nice Select - v1.0
 https://github.com/hernansartorio/jquery-nice-select
 Made by Hernán Sartorio  */
!function(e) {
	e.fn.niceSelect = function(t) {
		function s(t) {
			t.after(e("<div></div>").addClass("nice-select").addClass(t.attr("class") || "").addClass(t.attr("disabled") ? "disabled" : "").attr("tabindex", t.attr("disabled") ? null : "0").attr("title", t.attr("title")).html('<span class="current"></span><ul class="list"></ul>'));
			var s = t.next(), n = t.find("option"), i = t.find("option:selected");
			s.find(".current").html(i.data("display") || i.text()), n.each(function(t) {
				var n = e(this), i = n.data("display");
				s.find("ul").append(e("<li></li>").attr("data-value", n.val()).attr("data-display", i || null).addClass("option" + (n.is(":selected") ? " selected" : "") + (n.is(":disabled") ? " disabled" : "")).html(n.text()))
			})
		}
		
		if ("string" == typeof t) {
			return "update" == t ? this.each(function() {
				var t = e(this), n = e(this).next(".nice-select"), i = n.hasClass("open");
				n.length && (n.remove(), s(t), i && t.next().trigger("click"))
			}) : "destroy" == t ? (this.each(function() {
				var t = e(this), s = e(this).next(".nice-select");
				s.length && (s.remove(), t.css("display", ""))
			}), 0 == e(".nice-select").length && e(document).off(".nice_select")) : console.log('Method "' + t + '" does not exist.'), this;
		}
		this.hide(), this.each(function() {
			var t = e(this);
			t.next().hasClass("nice-select") || s(t)
		}), e(document).off(".nice_select"), e(document).on("click.nice_select", ".nice-select", function(t) {
			var s = e(this);
			e(".nice-select").not(s).removeClass("open"), s.toggleClass("open"), s.hasClass("open") ? (s.find(".option"), s.find(".focus").removeClass("focus"), s.find(".selected").addClass("focus")) : s.focus()
		}), e(document).on("click.nice_select", function(t) {
			0 === e(t.target).closest(".nice-select").length && e(".nice-select").removeClass("open").find(".option")
		}), e(document).on("click.nice_select", ".nice-select .option:not(.disabled)", function(t) {
			var s = e(this), n = s.closest(".nice-select");
			n.find(".selected").removeClass("selected"), s.addClass("selected");
			var i = s.data("display") || s.text();
			n.find(".current").text(i), n.prev("select").val(s.data("value")).trigger("change")
		}), e(document).on("keydown.nice_select", ".nice-select", function(t) {
			var s = e(this), n = e(s.find(".focus") || s.find(".list .option.selected"));
			if (32 == t.keyCode || 13 == t.keyCode) {
				return s.hasClass("open") ? n.trigger("click") : s.trigger("click"), !1;
			}
			if (40 == t.keyCode) {
				if (s.hasClass("open")) {
					var i = n.nextAll(".option:not(.disabled)").first();
					i.length > 0 && (s.find(".focus").removeClass("focus"), i.addClass("focus"))
				} else {
					s.trigger("click");
				}
				return !1
			}
			if (38 == t.keyCode) {
				if (s.hasClass("open")) {
					var l = n.prevAll(".option:not(.disabled)").first();
					l.length > 0 && (s.find(".focus").removeClass("focus"), l.addClass("focus"))
				} else {
					s.trigger("click");
				}
				return !1
			}
			if (27 == t.keyCode) {
				s.hasClass("open") && s.trigger("click");
			} else if (9 == t.keyCode && s.hasClass("open")) {
				return !1
			}
		});
		var n = document.createElement("a").style;
		return n.cssText = "pointer-events:auto", "auto" !== n.pointerEvents && e("html").addClass("no-csspointerevents"), this
	}
}(jQuery);
$(document).ready(function() {
	if (typeof jQuery().niceSelect !== 'undefined' && jQuery('.styled_select').length) {
		jQuery('.styled_select').niceSelect();
	}
});

var map;
var href = window.location.href;
var _get = [];
var params;
if (href.indexOf('?')) {
	params = href.substr(href.indexOf('?') + 1);
	params = params.split("&");
}
for (var i in params) {
	if (isNaN(i)) {
		continue;
	}
	if (params[i].indexOf('=')) {
		var att_val = params[i].split('=');
		_get[att_val[0]] = att_val[1];
	}
}

String.prototype.stripTags = function() {
	return this.replace(/<([^>]+)>/g, '');
};

// String.prototype.startsWith = function(s) {
// 	return (this.match("^" + s) === s);
// };

if (typeof(document.getElementsByClassName) !== 'function') {
	document.getElementsByClassName = function(searchClass, tag) {
		var classElements = [];
		if (!tag) {
			tag = '*';
		}
		var els = document.getElementsByTagName(tag);
		var elsLen = els.length;
		var pattern = new RegExp("(^|\\s)" + searchClass + "(\\s|$)");
		for (i = 0, j = 0; i < elsLen; i++) {
			if (pattern.test(els[i].className)) {
				classElements[j] = els[i];
				j++;
			}
		}
		return classElements;
	};
}

if (!tick) {
	var tick = function() {
	};
}

var tooltip = function() {
	var id = 'tooltip';
	var maxw = 300;
	var tt, h, tt_show;
	var ie = document.all ? true : false;
	return {
		show: function(v, w) {
			if (window.mobile_agent || window.is_ipad) {
				return;
			}
			if (!tt) {
				tt = document.createElement('div');
				tt.style.position = 'absolute';
				tt.style.backgroundColor = '#ffffff';
				tt.style.border = '1px solid #333333';
				tt.style.padding = '3px';
				tt.style.fontSize = '11px';
				tt.style.zIndex = 2000;
				tt.setAttribute('id', id);
				document.body.appendChild(tt);
				document.onmousemove = this.pos;
			}
			tt.style.display = 'block';
			tt.innerHTML = v;
			tt.style.width = w ? w + 'px' : 'auto';
			if (!w && ie) {
				tt.style.display = 'none';
				tt.style.width = tt.offsetWidth;
				tt.style.display = 'block';
			}
			if (tt.offsetWidth > maxw) {
				tt.style.width = maxw + 'px';
			}
			h = parseInt(tt.offsetHeight, 10) + 3;
			tt.style.display = 'none';
			tt_show = true;
		},
		pos: function(e) {
			var u = ie ? event.clientY + document.documentElement.scrollTop : e.pageY;
			var l = ie ? event.clientX + document.documentElement.scrollLeft : e.pageX;
			if (tt_show) {
				tt.style.display = 'block';
				tt_show = false;
			}
			tt.style.top = (u - h) + 'px';
			tt.style.left = (l + 3) + 'px';
		},
		hide: function() {
			if (typeof(tt) !== 'undefined') {
				tt.style.display = 'none';
			}
		}
	};
}();

function plp_init() { // plp = page load popup
	const $body = jQuery('body');
	$body.on('plp_show', '.js-plp', function() {
		let $this = jQuery(this);
		if (!$this.hasClass('plp--static')) {
			yalwa.basics.show(jQuery('.js-plp_container'));
			if ($this.hasClass('js-use-generic-shadow')) {
				yalwa.desktop.generic_shadow.show();
			}
		}
		yalwa.basics.show($this);
		if ($this.hasClass('js-plp_hide_shadowclick')) {
			jQuery('.js-generic_shadow').on('click.hide_shadowclick', function() {
				jQuery('.js-generic_shadow').off('click.hide_shadowclick');
				$this.trigger('plp_hide');
			});
		}
	});
	$body.on('plp_hide', '.js-plp', function() {
		const $this = jQuery(this);
		if (!$this.hasClass('plp--static')) {
			yalwa.basics.hide(jQuery('.js-plp_container'));
			if ($this.hasClass('js-use-generic-shadow')) {
				yalwa.desktop.generic_shadow.hide();
			}
		}
		yalwa.basics.hide($this);
	});
	jQuery('.js-plp').not('.js-plp_wait').each(function() {
		jQuery(this).trigger('plp_show');
	});
	$body.on('click', '.js-plp_ok,.js-plp_close', function() {
		const $this = jQuery(this);
		$this.closest('.js-plp').trigger('plp_hide');
		if ($this.hasClass('js-plp_ok')) {
			$this.closest('.js-plp').trigger('plp_ok');
		}
	});
	$body.on('click', '.js-plp_confirm', function() {
		const $tmp = jQuery(this).closest('.js-plp');
		$tmp.trigger('plp_confirm');
		if (!$tmp.hasClass('js-plp_no_autohide')) {
			$tmp.trigger('plp_hide');
		}
	});
	if (yalwa.v.is_ios) {
		jQuery('.js-plp').on('touchmove', ios_prevent_background_scrolling);
	}
}

function toggle_more_place() {
	if (jQuery('a.toggle_more_places').length < 0) {
		return;
	}
	jQuery('a.toggle_more_places').show().click(function() {
		jQuery('a.toggle_more_places').closest('li').toggle();
		jQuery('.toggle_more_places').toggle();
		return false;
	});
}

function addslashes(str) {
	str = str.replace(/\'/g, '\\\'');
	str = str.replace(/\"/g, '\\"');
	str = str.replace(/\\/g, '\\\\');
	str = str.replace(/\0/g, '\\0');
	return str;
}

function url_decode(str) {
	return unescape(str.replace(/\+/g, " "));
}

function clear_default_area() {
	var loc = window.location.href.split('.');
	var pos = loc.length - 1;
	loc[pos] = loc[pos].substring(0, loc[pos].search('/'));
	var domain = loc[pos].split(':')[0];
	for (var i = pos - 1; i > 0; i--) {
		domain = loc[i] + '.' + domain;
	}
	
	document.cookie = 'loc_default_area=1;domain=' + domain + ';expires=Thu, 01-Jan-1970 00:00:01 GMT;path=/';
}

function getKeyCode(event) {
	event = event || window.event;
	return event.keyCode;
}

function T$(i) {
	return document.getElementById(i);
}

function isArray(a) {
	return isObject(a) && a.constructor === Array;
}

function isObject(a) {
	return (a && typeof a === 'object') || isFunction(a);
}

function isFunction(a) {
	return typeof a === 'function';
}

function fireEvent(element, event) {
	var evt;
	if (document.createEventObject) {// dispatch for IE
		evt = document.createEventObject();
		return element.fireEvent('on' + event, evt);
	} else { // dispatch for firefox + others
		evt = document.createEvent("HTMLEvents");
		evt.initEvent(event, true, true); // event type,bubbling,cancelable
		return !element.dispatchEvent(evt);
	}
}

function hide_odr_link_box() {
	if (yalwa.basics.ls_get('hide_odr_box') !== '1') {
		jQuery('.js-odr_box').removeClass('hidden');
	}
}

function sharer_click(obj) {
	var $obj = jQuery(obj);
	var w, h;
	if (typeof arguments[1] !== 'undefined') {
		w = arguments[1];
	} else {
		w = 626;
	}
	if (typeof arguments[2] !== 'undefined') {
		h = arguments[2];
	} else {
		h = 436;
	}
	
	var provider;
	if (typeof arguments[3] !== 'undefined') {
		provider = arguments[3];
	} else if ($obj.data('share_provider')) {
		provider = $obj.data('share_provider');
	}
	
	if (provider) {
		var position;
		if (typeof arguments[4] !== 'undefined') {
			position = arguments[4];
		} else if ($obj.closest('[data-share_position]').length) {
			position = $obj.closest('[data-share_position]').data('share_position');
		} else {
			position = 'VAP';
		}
		
		if (window.href.indexOf('my-ads') > -1) {
			position = 'Account Section -> My Ads';
		}
		
		if (window.href.indexOf('by/') > -1) {
			position = 'Public Profile Page';
		}
		const data = {category: 'Share box', action: position, label: arguments[3]};
		yalwa.basics.ga.ping_metric('CM_SHARE', 1, data);
		
	}
	
	jQuery(document).trigger('sm_share_click');
	var popup = window.open($obj.attr('href'), 'sharer', 'noopener,toolbar=0,status=0,width=' + w + ',height=' + h + ',screenX=' + (Math.round((jQuery(window).width() / 2) - (w / 2))) + ',screenY=' + (Math.round((jQuery(window).height() / 2) - (h / 2))));
	var id = setInterval(function() {
		// try to close the popup after the share (facebook loads the current page in popup after share
		try {
			if (popup.location && popup.location.origin && popup.location.origin === window.location.origin) {
				popup.close();
				clearInterval(id);
			}
		} catch (e) {
		}
	}, 1000);
	return false;
}
let $form;
function setup_search_form() {
	$form = jQuery('#search_form');
	var $remove_icon = jQuery('<span></span>');
	
	$remove_icon
		.attr('id', 'input_hover')
		.addClass('icon_16')
		.addClass('ui-icon')
		.addClass('ui-icon-circle-close')
		.on('click', function() {
			jQuery('#search_form input[name="query"]').val('');
		});
	$remove_icon.insertBefore(jQuery('#search_form input[name="query"]'));
	$form.on('submit', (event) => {
		before_submit();
		event.preventDefault();
		jQuery(event.target).find('.js-geo_search_topnav').attr('name', 'area');
		jQuery(event.target).off('submit');
		jQuery(event.target).submit();
	})
	jQuery('#search_form button[type="submit"]').on('click', function() {
		var $form = jQuery('#search_form');
		if (!$form.find('input[name="query"]').val()) {
			$form.find('input[name="query"]').prop('disabled', true);
		}
		
		var $dist_form = $form.find('select[name="dist"]');
		var $area_search_form = $form.find('.js-geo_search_topnav');
		var $geo_input_form = $form.find('input[name="geoid"]');
		
		if ($dist_form.val() === 'max') {
			$dist_form.prop('disabled', true);
			$area_search_form.val('').prop('disabled', true);
			$geo_input_form.val(-1);
		} else {
			if ((!yalwa.v.current_distance || yalwa.v.current_distance == '0') && ($dist_form.val() == '0' || $dist_form.val() === '')) {
				$dist_form.prop('disabled', true);
			}
			
			if ($geo_input_form.val() === '0') {
				$geo_input_form.prop('disabled', true);
			}
		}
		
		if ($remove_icon) {
			$remove_icon.remove();
		}
		$form.find('input[name="query"]').addClass('loading');
	});
}

const before_submit = _ => {
	if (yalwa.v.SEO_CANNIBALIZATION_TESTING) {
		query_handling();
	}
	geoid_handling();
	area_handling();
}

const query_handling = _ => {
	const $query_input = $form.find('input[name="query"]');
	$query_input.val($query_input.val().toLowerCase());
}

const geoid_handling = _ => {
	const $geoid_input = $form.find('input[name="geoid"]');
	disable_if_empty($geoid_input);
}

const area_handling = _ => {
	const $area_input = $form.find('.js-geo_search_topnav');
	disable_if_empty($area_input);
}

const disable_if_empty = $input => {
	$input.attr('disabled', !$input.val());
}

function ios_prevent_background_scrolling(e)  {
	e.preventDefault();
	e.stopPropagation();
}

yalwa.desktop = (function(pub) {
	'use strict';
	
	pub = pub || {};
	let $document, $body;
	function is_mobile_device(string) {
		if (string === undefined) {
			string = navigator.userAgent.toLowerCase();
		}
		
		var strings = [
			'sony', 'symbian', 'nokia', 'samsung', 'iphone', 'mobile', 'android', 'iemobile', 'windows ce', 'epoc',
			'opera mini', 'nitro', 'htc', 'j2me', 'midp-', 'cldc-', 'netfront', 'mot', 'up.browser', 'up.link',
			'audiovox', 'blackberry', 'ericsson,', 'panasonic', 'philips', 'sanyo', 'sharp', 'sie-', 'portalmmm',
			'blazer', 'avantgo', 'danger', 'palm', 'series60', 'pocketpc', 'smartphone', 'rover', 'ipaq', 'au-mic,',
			'alcatel', 'ericy', 'vodafone/', 'wap1.', 'wap2.'
		];
		
		for (var i = 0; i < strings.length; i++) {
			if (string.indexOf(strings[i]) !== -1) {
				return true;
			}
		}
		return false;
	}

	function check_dol_reminder_top() {
		const $reminder_dol = jQuery('.js-dol_reminder');
		if (!$reminder_dol.length) {
			return;
		}
		let dol_reminder_action_count = 0;
		let actual_user_status = $reminder_dol.data('user_status') || false;
		let user_status = yalwa.basics.ls_get('dol_reminder_user_status') || false;
		if (actual_user_status && (actual_user_status !== user_status)) {
			yalwa.basics.set_cookie('dol_reminder_action_count', 0, -1);
		}
		yalwa.basics.ls_set('dol_reminder_user_status', actual_user_status);
		$reminder_dol.velocity('fadeIn', {
			display: '',
			complete: function() {
				jQuery("html, body").animate({scrollTop: 0}, "slow");
			}}
		).removeClass('invisible');
		$reminder_dol.on('click', function() {
			yalwa.basics.set_cookie('dol_reminder_clicked', dol_reminder_action_count + 1, 86400);
			yalwa.basics.set_cookie('dol_reminder_action_count', (yalwa.basics.get_cookie('dol_reminder_action_count') || 0) + 1);
		});
		jQuery('.js-dol_reminder_close').on('click', function(event) {
			event.preventDefault();
			yalwa.basics.set_cookie('dol_reminder_clicked', dol_reminder_action_count + 1, 86400);
			yalwa.basics.set_cookie('dol_reminder_action_count', (yalwa.basics.get_cookie('dol_reminder_action_count') || 0) + 1);
			yalwa.basics.hide(jQuery('.js-dol_reminder').velocity('fadeOut', {display: ''}));
			return false;
		});
	}
	
	window.is_ipad = (navigator.userAgent.toLowerCase().indexOf('ipad') > -1);
	
	pub.active_map = false;
	
	pub.set_map = function(gmap) {
		pub.active_map = gmap;
	};
	
	pub.darken_background = function(undarken) {
		if (jQuery('.darken_background').length) {
			jQuery('.darken_background').fadeIn().off().on('click', function() {
				jQuery('.darken_background').fadeOut();
				if (undarken) {
					undarken();
					return false;
				}
			});
		}
	};
	
	pub.init = function() {
		$document = jQuery(document);
		$body = jQuery('body');
		
		if (jQuery('.js-searchbox_new').length) {
			setup_search_form();
		}
		
		if (!yalwa.v.disable_setup_login_desktop) {
			setup_login();
		}
		
		var $html = jQuery('html');
		
		jQuery('.js-odr_box a').on('click', function() {
			yalwa.basics.ls_set('hide_odr_box', 1);
		});
		
		hide_odr_link_box();
		
		jQuery('.was_ok').on('click', function() {
			jQuery('#modal_after_delete').fadeOut();
			if (yalwa.v.manage_ad) {
				jQuery('#delete_ad_question').css('display', 'none');
				jQuery('.js_hide-on-success').css('display', 'none');
				jQuery('#question_confirm').fadeIn();
			}
		});
		
		jQuery('.was_not_ok').on('click', function() {
			jQuery('#modal_after_delete').fadeOut();
			if (yalwa.v.manage_ad) {
				jQuery('#delete_ad_question').css('display', 'none');
				jQuery('.js_hide-on-success').css('display', 'none');
				jQuery('#question_confirm').fadeIn();
			}
		});
		
		if (yalwa.v.load_last_searches) {
			init_last_searches();
		}
		
		if (yalwa.v.upid_key === 'locanto') {
			init_search_suggestions();
		}
		
		if (yalwa.v.show_fixed_metas) {
			init_fixed_metas_affix();
		}
		
		if (yalwa.v.shopping_cart_count) {
			jQuery('[rel="shortcut icon"]').attr('href',yalwa.basics.get_cart_not_empty_favicon());
		}
		
		pub.init_tooltips();
		init_delete_location_button();
		
		jQuery('.ysm_wrapper').on('click', function(e) {
			if (jQuery(e.target).closest('.js-contact_follow_toggle').length) {
				return;
			}
			if (yalwa.v.modal_unclosable === undefined ||
				yalwa.v.modal_unclosable != jQuery(this).attr('id')
			) {
				jQuery('.ysm_wrapper').fadeOut();
				jQuery('#main').removeClass('blured');
			}
		});
		
		jQuery('.js-back_button').on('click', function() {
			window.history.back();
		});
		
		jQuery('.ysm').on('click', function(e) {
			if (e.target.href === undefined && !jQuery(e.target).hasClass('popup_submit') && !jQuery(e.target).closest('.js-contact_follow_toggle').length) {
				e.preventDefault();
				e.stopPropagation();
			}
		});
		
		jQuery('a.js-popup_link').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var link = jQuery(this).attr('href');
			if (link) {
				window.location.href = link;
			}
			
		});
		
		jQuery('.js-open_user_online_pa_promo').on('click', yalwa.desktop.open_user_online_pa_promo_click);
		
		jQuery('.js-ignore_user_btn').on('click', function(e) {
			e.preventDefault();
			jQuery('#main').addClass('blured');
			jQuery('#vap_pa_promo_ignoreuser_popup').fadeIn();
		});
		
		jQuery('.js-show_phone_verification_popup').on('click', function(e) {
			if (jQuery('#pa_promo_phone_verification_popup').length) {
				e.preventDefault();
				e.stopPropagation();
				jQuery('#main').addClass('blured');
				jQuery('#pa_promo_phone_verification_popup').fadeIn();
			}
		});
		
		jQuery('.js-show_premium_label_popup').on('click', function(e) {
			e.preventDefault();
			jQuery('#main').addClass('blured');
			jQuery('#vap_pa_promo_premium_label_popup').fadeIn();
		});
		
		$body.on('click', '.js-show_follow_promo_popup', function(e) {
			e.preventDefault();
			jQuery('#main').addClass('blured');
			jQuery('#pa_info_followers').css('z-index', '100000')
			jQuery('#pa_info_followers').fadeIn();
		});
		
		if (yalwa.v.activate_navigation_affix) {
			navigation_affix();
		}
		
		if (jQuery('.js-dlocal_overlay_promo').length > 0) {
			jQuery('.js-dlocal_overlay_promo').on('plp_hide', () => {
				yalwa.basics.set_cookie('dlocal_overlay_shown', 1, 2592000);
			});
			jQuery('.js-dlocal_overlay_close').on('click', () => {
				yalwa.basics.set_cookie('dlocal_overlay_shown', 1, 2592000);
			});
		}
		
		jQuery('.js-my_ratings_delete').on('click', function() {
			var t = jQuery(this);
			var data = t.data();
			var reviewID = data.reviewid;
			var ctrl_str = data.ctrl_str;
			jQuery.post('/api/ajax/user_rating', {
				'action': 'delete_rating_request',
				'reviewID': reviewID,
				'ctrl_str': ctrl_str
			}, function(status) {
				if (status == 'success') {
					t.closest('.my_ratings_interface__rating_wrapper').fadeOut();
				}
			});
		});
		
		// Reveal password
		jQuery('body').on('touchend click', '.js-reveal_password', function(e) {
			const $icon = jQuery(this).children('.yicon');
			$icon.toggleClass('sprites_desktop_main__eye-crossed-out sprites_desktop_main__eye');
			
			const $input = jQuery(this).closest('label').find('input');
			const type = yalwa.v.is_ios ? $input.attr('type') : $input.prop('type');
			const new_type = type === 'text' ? 'password' : 'text';
			$input.prop('type', new_type).attr('type', new_type);// .attr needed for iOS
			
			e.preventDefault();
			e.stopPropagation(); // so the keyboard doesn't reveal
		});
		
		$body.on('mouseover', function() {
			yalwa.basics.hide(jQuery('.premium_label_hover_show'));
			yalwa.basics.hide(jQuery('.browse_rating_info'));
		});
		
		jQuery('.browse_rating').on('mouseover', function(e) {
			e.stopPropagation();
			yalwa.basics.show(jQuery(this).parent().find('.browse_rating_info'));
		});
		
		jQuery('.premium_label_wrapper').on('mouseover', function(e) {
			e.stopPropagation();
			yalwa.basics.show(jQuery(this).find('.premium_label_hover_show'));
		});
		
		jQuery('.premium_label_hover_show')
			.on('mouseover', function(e) {
				e.stopPropagation();
			})
			.on('click', function(e) {
				e.preventDefault();
				window.location.href = '/info/premium-accounts/premium-label';
			});
		
		yalwa.basics.init_nickname_dialog();
		init_nickname_blur();
		
		if (jQuery('.confirmation_reminder--sc').length && Math.random() <= 0.01) {
			yalwa.basics.ga.event({
				category: 'cart_promo_view',
				action: 'header-bar',
				label: 'v1',
			});
		}
		
		init_container_click_propagation();
		check_ie_scroll_jank_fix();
		check_routing();
		yalwa.desktop.generic_shadow.init();
		plp_init();
		yalwa.basics.auth.init();
		
		if (yalwa.basics.get_cookie('paf_post') == true) {
			yalwa.basics.ss_remove('paf_start_tracked')
			yalwa.basics.set_cookie('paf_post', 0);
		}
		check_paf_started();
		toggle_more_place();
		pub.nlp.init();
		check_dol_reminder_top();
		if (jQuery('.js-dating_landing_area_tracker').length) {
			var $add_tracking = jQuery('.js-dating_landing_area_tracker');
			var track_country = $add_tracking.data('country');
			var track_area = $add_tracking.data('area');
			$add_tracking.find('a').on('click', function(e) {
				yalwa.basics.ga.event({
					category: 'chp_ahp_dol_promo_click',
					action: String(track_country),
					label: track_area && track_area > 0 ? String(track_area) : ''
				});
			});
		}
		if (yalwa.v.show_back_to_top_btn !== undefined) {
			init_back_to_top();
		}
		if (yalwa.v.is_public_profile_page !== undefined) {
			init_public_profile();
		}
		
		if ((typeof yalwa.v.aid === 'undefined' || !yalwa.v.aid <= 0)
			&& (typeof yalwa.v.current_geoID === 'undefined' || yalwa.v.current_geoID <= 0)) {
			init_disabled_searchbtn_nosearch();
		}
		
		if (jQuery('.js-ip_hint,.js-ip_hint_city').length) {
			const $this = jQuery('.js-ip_hint,.js-ip_hint_city');
			jQuery.ajax({url: ($this.hasClass('js-ip_hint_city') ? '/api/ajax/check_city/' : '/api/ajax/check_ip/')}).done((label) => {
				$this.prepend(label).removeClass('invisible');
				jQuery('.js-ip_hint_close').on('click', ip_hint_close);
			});
		}
		
		if (yalwa.v.NEW_SEARCH_FILTERS) {
			jQuery('.js-search_filter_button').on('click', load_search_filter);
		}
		check_read_only();
		init_magic_link_tracking();
		if (yalwa.v.ml_token_invalid) {
			yalwa.basics.toast({message: yalwa.v.lang.magic_link_error_expired, type: 'error'});
		}
		jQuery('.js-lost_pw_ml_btn').on('click', () => {
			yalwa.desktop.auth.show_dialog().done(() => {
				yalwa.desktop.magic_link.toggle_to_ml_form()
			});
		});
		jQuery('#tckr_containerHider').parent().on('click', '.js-vap_touchpoint_generic', function() {
			yalwa.basics.set_VAP_touchpoint(jQuery(this).data('touchpoint'));
		});
		jQuery('.js-vap_touchpoint_generic').on('click', function() {
			yalwa.basics.set_VAP_touchpoint(jQuery(this).data('touchpoint'));
		});
		
		const $link = jQuery('link[rel="alternate"][media]');
		if ($link.length && $link.attr('href').search('https://m.') !== 0) {
			yalwa.basics.sentry.submit_error_with_options('alternate URL without mobile subdomain', { extra: { href: encodeURIComponent($link.attr('href'))}});
		}
		import(yalwa.basics.static_url('js') + 'mobile/modules/dol_stream_promo.js').then((Module) => {
			const dol_stream_promo = new Module.DolStreamPromo();
		});
		
	};
	
	pub.auth = (function(pub) {
		
		let loaded;
		let redirect_to;
		let success_handler;
		let init_register = false;
		let ajax_login_no_register = false;
		const labels = {};
		let touchpoint;
		const $login_buttons = jQuery('.js-headroom_login_button, .js-default_login, .js-default_register');
		const $ignored_links = jQuery('.js-ajax_ignore');
		let ajax_login_benefits_slider;
		
		pub = pub || {};
		
		pub.init = function() {
			yalwa.basics.auth.init();
		};
		
		pub.autoload = function() {
			return false;
		};
		
		pub.update_login_handlers = function() {
			if (!yalwa.basics.auth.use_ajax()) {
				return;
			}
			if (yalwa.basics.is_logged_in()) {
				return;
			}
			const $login_buttons = jQuery('.js-headroom_login_button, .js-default_login, .js-default_register');
			const $ignored_links = jQuery('.js-ajax_ignore');
			$login_buttons
				.not($ignored_links)
				.off('click.load_login')
				.on('click.load_login', pub.show_dialog);
			if (!yalwa.basics.is_logged_in()) {
				var $links = jQuery('a[href*="\/my\/"]')
					.not($ignored_links)
					.not($login_buttons)
					.not('[href*="\/activate"]');
				$links
					.off('click.load_login_links')
					.on('click.load_login_links', function(e) {
						yalwa.basics.auth.redirect_to = jQuery(this).attr('href');
						pub.show_dialog(e);
					});
			}
		};
		
		pub.update_logout_handlers = function() {
			
			if (!yalwa.basics.auth.use_ajax()) {
				return;
			}
			if (!yalwa.basics.is_logged_in()) {
				return;
			}
			jQuery('body').off('click', '.js-logout').on('click', '.js-logout', function(e) {
				e.preventDefault();
				yalwa.basics.before_logout().done(() => {
					yalwa.basics.auth.logout().done(function(response) {
						if (response.success) {
							yalwa.basics.toast({message: response.message, type: 'success'});
							//Turn off auto sign-in for future visits
							if (yalwa.basics.auth.credential_api_support()) {
								navigator.credentials.preventSilentAccess();
							}
							setTimeout(function() {
								if (['login', 'logout'].indexOf(yalwa.basics.get_routing()) !== -1) {
									yalwa.basics.navigate(yalwa.basics.get_get('continue') ? yalwa.basics.get_get('continue') : yalwa.v.chp_url);
								} else {
									yalwa.basics.reload();
								}
							}, 200);
						} else {
							yalwa.basics.toast({message: response.message, type: 'error'});
						}
					});
					return false;
				});
			});
		};
		
		pub.show_dialog = function(e, forbid_cancel, default_register) {
			let $clicked_element = false;
			if (e) {
				if (jQuery(e.currentTarget).not($ignored_links).not($login_buttons).length) {
					yalwa.basics.auth.redirect_to = jQuery(e.currentTarget).attr('href');
				}
				$clicked_element = jQuery(e.currentTarget);
			}
			let deferred = jQuery.Deferred();
			var $login = jQuery('.js-login_modal');
			init_register = !!(default_register || ($clicked_element ? (!$clicked_element.hasClass('js-default_login') && !$clicked_element.hasClass('js-headroom_login_button')) : false));
			touchpoint = e ? determine_touchpoint(jQuery(e.currentTarget)) : 1;

			if (!loaded) {
				const data = {};
				data[yalwa.basics.auth.touchpoint_parameter()] = touchpoint;
				if (pub.autoload()) {
					login_form_init(forbid_cancel);
					deferred.resolve();
				} else {
					yalwa.basics.load_template_json_once('template_login_json', jQuery('.js-login_modal'), false, data).done((data) => {
						if (data) {
							jQuery.extend(labels, data.labels);
						}
						login_form_init(forbid_cancel);
						yalwa.desktop.magic_link.init(labels.magic_link);
						deferred.resolve();
					});
				}
				loaded = true;
			} else {
				set_touchpoint(touchpoint).done(function() {
					if ($login.hasClass('hidden')) {
						dialog_show(forbid_cancel);
						show_section(init_register ? 'register' : 'login');
					} else {
						dialog_hide();
					}
					deferred.resolve();
				});
			}
			if (e) {
				e.preventDefault();
			}
			return deferred.promise();
		};
		
		pub.register_success_handler = function(callback) {
			success_handler = callback;
		};
		
		function set_touchpoint(tp) {
			return jQuery.ajax({
				url: '/api/ajax/general',
				type: 'post',
				dataType: 'json',
				data: {
					action: 'set_touchpoint',
					tp: tp
				}
			});
		}
		
		function determine_touchpoint($element) {
			touchpoint = $element.attr('href') && $element.attr('href') !== '#' ? new URL($element.attr('href')).searchParams.get(yalwa.basics.auth.touchpoint_parameter()) : null;
			touchpoint = $element.data(yalwa.basics.auth.touchpoint_parameter()) ? $element.data(yalwa.basics.auth.touchpoint_parameter()) : touchpoint;
			return touchpoint;
		}
		
		function prepare_labels() {
			if (!touchpoint) {
				touchpoint = 1;
			}
			const used_label_set = labels[touchpoint] ? labels[touchpoint] : labels['default'];
			jQuery('.js-ajax_login_heading').html(used_label_set.login_heading);
			jQuery('.js-register_link').html(used_label_set.login_subheading);
			jQuery('.js-ajax_register_heading').html(used_label_set.register_heading);
		}
		
		function show_section(section) {
			if (section === 'register') {
				yalwa.basics.auth.hotjar_ajax_register_tab();
			} else {
				yalwa.basics.auth.hotjar_ajax_login();
			}
			jQuery('.js-ltabs_item[data-value="' + section + '"]').trigger('click');
			show_section_event_tracking(section);
		}
		
		function show_section_event_tracking(section) {
			yalwa.basics.ga.event({
				category: 'ajax_login_show_section',
				action: section,
				label: 'desktop'
			});
		}
		
		function init_dialog_tabs() {
			if (ajax_login_no_register) {
				jQuery('.js-ltabs').addClass('hidden');
				show_section('login');
				jQuery('.ajax_login__content').addClass('ajax_login__no_register_corners');
				ajax_login_no_register = false;
			} else {
				jQuery('.js-ltabs').removeClass('hidden');
				jQuery('.ajax_login__content').removeClass('ajax_login__no_register_corners');
			}
		}
		
		function dialog_show(forbid_cancel) {
			init_dialog_tabs();
			const $modal = jQuery('.js-login_modal');
			if (pub.autoload()) {
				jQuery('.js-login_modal').detach().addClass('ajax_login--static').appendTo(jQuery('.js-page_unique'));
			} else {
				yalwa.desktop.generic_shadow.show(forbid_cancel ? {} : {onclick: dialog_hide});
			}
			// do not allow chrome to autocomplete before ali initialized
			const $login_id_input = $modal.find('.js-login_id');
			const $login_input_click_area = $login_id_input.closest('label');
			$login_input_click_area.on('click', function() {
				$login_id_input.attr('disabled', false);
			});
			if (!pub.autoload()) {
				prepare_labels();
			}
			yalwa.basics.show($modal);
			$modal.trigger('click');
			$document.trigger('login_dialog_show', null);
		}
		
		function dialog_hide() {
			if (!pub.autoload()) {
				yalwa.desktop.generic_shadow.hide(true);
				yalwa.basics.hide(jQuery('.js-login_modal'));
				show_register_form_button();
			}
		}
		
		function init_toggle_register_form_button() {
			const $button = jQuery('.js-ajax_register_show_form');
			if (!$button.length) {
				return;
			}
			const $register_form = jQuery('.js-register_form');
			$button.on('click', function(event) {
				event.preventDefault();
				ajax_login_benefits_slider.hide();
				yalwa.basics.toggle($button);
				yalwa.basics.toggle($register_form);
				jQuery('.js-ajax_register_email').focus();
			});
		}
		
		function show_register_form_button() {
			const $button = jQuery('.js-ajax_register_show_form');
			if (!$button.length) {
				return;
			}
			const $register_form = jQuery('.js-register_form');
			yalwa.basics.show($button);
			yalwa.basics.hide($register_form);
			ajax_login_benefits_slider.show();
		}
		
		function login_form_init(forbid_cancel) {
			if (jQuery('.js-ajax_login_read_only').length) {
				yalwa.basics.toast({message: jQuery('.js-ajax_login_read_only').html().replace(/<br>/g, ''), type: 'error'});
				return;
			}
			yalwa.desktop.ali.init();
			const ltabs_types = {
				login: 'login',
				register: 'register',
				chosen: 'login',
				other: 'register'
			};
			jQuery(document).on('ltabs_login', function() {
				if (jQuery('.ltabs__item--chosen').data('value') === ltabs_types.login) {
					ltabs_types.chosen = ltabs_types.login;
					ltabs_types.other = ltabs_types.register;
				} else {
					ltabs_types.chosen = ltabs_types.register;
					ltabs_types.other = ltabs_types.login;
				}
				jQuery('.js-login_section[data-value="' + ltabs_types.chosen + '"]').addClass('chosen');
				jQuery('.js-login_section[data-value="' + ltabs_types.other + '"]').removeClass('chosen');
			});
			jQuery('.js-login_stay').on('click', function() {
				jQuery(this).toggleClass('checked');
			});
			yalwa.desktop.ltabs.init();
			if (pub.autoload() && yalwa.basics.get_routing() === 'registration' || init_register) {
				show_section('register');
			}
			init_register = false;
			jQuery('.js-login_id').on('keypress', function(e) {
				if (e.which == 13) {
					jQuery('.js-ajax_login_submit').trigger('click');
				}
			});
			jQuery('.js-ajax_register_email').on('keypress', function(e) {
				if (e.which == 13) {
					jQuery('.js-ajax_register_submit').trigger('click');
				}
			});
			jQuery('.js-login_pw').on('keypress', function(e) {
				if (e.which == 13) {
					jQuery('.js-ajax_login_submit').trigger('click');
				}
			});
			var in_progress = false;
			const $login_submit_button = jQuery('.js-ajax_login_submit');
			const $register_submit_button = jQuery('.js-ajax_register_submit');
			const login_form = $login_submit_button.closest('form')[0];
			const register_form = $register_submit_button.closest('form')[0];
			const validity_support = typeof login_form.checkValidity === 'function';
			const validity_report_support = typeof login_form.reportValidity === 'function';

			// polyfill for html5 reportValidity()
			if (!validity_report_support) {
				login_form.addEventListener('invalid', function(event) {
					if (!jQuery('.locanto_toast').length) {
						yalwa.basics.toast({message: event.target.validationMessage, type: 'error'});
					}
				}, true);
				register_form.addEventListener('invalid', function(event) {
					if (!jQuery('.locanto_toast').length) {
						yalwa.basics.toast({message: event.target.validationMessage, type: 'error'});
					}
				}, true);
			}
			
			// Fix PLP after register form submit
			jQuery('.js-register_form').on('submit', function(e) {
				e.preventDefault();
			})

			$login_submit_button.on('click', function(e) {
				e.preventDefault();
				const $login_id_input = jQuery(login_form).find('.js-login_id');
				// disabled inputs are always valid
				if ($login_id_input.attr('disabled')) {
					$login_id_input.attr('disabled', false);
					$login_id_input.focus();
				}
				if (validity_support && !login_form.checkValidity()) {
					if (validity_report_support) {
						login_form.reportValidity();
					}
					return;
				}
				if (in_progress) {
					return;
				}
				in_progress = true;
				yalwa.basics.auth.login(
					jQuery('.js-login_id').val(),
					jQuery('.js-login_pw').val(),
					jQuery('.js-login_stay').hasClass('checked') ? 1 : 0,
					jQuery('.js-login_csrf').data('key'),
					jQuery('.js-login_csrf').val()
				).done(function(response) {
					in_progress = false;
					if (response.success) {
						yalwa.v.is_logged_in = true;
						yalwa.basics.toast({message: response.message, type: 'success'});
						jQuery('.js-headroom_login_button').remove();
						yalwa.basics.webpush.unsubscribe();
						if (success_handler) {
							dialog_hide();
							success_handler();
						} else {
							dialog_hide();
						}
						//make sure login success message visible enough
						window.setTimeout(() =>  {
							if (yalwa.basics.auth.redirect_to) {
								yalwa.basics.navigate(yalwa.basics.auth.redirect_to)
							} else {
								yalwa.basics.reload();
							}
						},500);
					} else {
						yalwa.basics.toast({message: response.message, type: 'error'});
					}
				});
			});
			$register_submit_button.on('click', function(e) {
				if (validity_support && !register_form.checkValidity()) {
					if (validity_report_support) {
						register_form.reportValidity();
					}
					return;
				}
				if (in_progress) {
					return;
				}
				in_progress = true;
				jQuery(this).prop('disabled', true);
				yalwa.basics.auth.register(jQuery('.js-ajax_register_email').val()).done(function(response) {
					in_progress = false;
					if (response.success) {
						dialog_hide();
						$body.append(response.html);
						setTimeout(function() {
							yalwa.desktop.check_for_detach();
							jQuery('.js-ajax_register_plp').trigger('plp_show');
						}, 500);
					} else {
						e.target.disabled = false;
						yalwa.basics.toast({title: response.title ,message: response.text, type: 'error'});
					}
				});
			});
			jQuery('.js-social_media_login_info').on('click', function(event) {
				jQuery('.js-social_media_login_info_details').toggle();
				event.preventDefault();
			});
			prepare_register_hint_label();
			prepare_login_hint_label();
			dialog_show(forbid_cancel);
			yalwa.basics.auth.gsi.render_button();
			init_toggle_register_form_button();
			ajax_login_benefits_slider = new yalwa.basics.simple_auto_slide({
				css_prefix:'ajax_login__'
			});
			ajax_login_benefits_slider.start();
			$document.trigger('login_dialog_initialized');
		}
		
		function prepare_register_hint_label() {
			const $register_link = jQuery('.js-register_hint a');
			$register_link.on('click', function(e) {
				e.preventDefault();
				show_section('register');
			});
		}
		
		function prepare_login_hint_label() {
			const $login_link = jQuery('.js-login_hint a');
			$login_link.on('click', function(e) {
				e.preventDefault();
				show_section('login');
			})
		}
		
		return pub;
		
	}(pub.auth));
	
	pub.ltabs = (function(pub) {
		
		pub = pub || {};
		var class_chosen = 'ltabs__item--chosen';
		var class_item = 'js-ltabs_item';
		var class_container = 'js-ltabs';
		var class_track = 'js-ltabs_track';
		
		pub.init = function() {
			jQuery('.' + class_container).each(init_instance);
			jQuery('.' + class_item).on('click', item_click);
		};
		
		function init_instance() {
			var $ltabs = jQuery(this);
			get_track($ltabs).css({
				width: (100 / (get_tab_count($ltabs) * 2)) + '%',
				transform: 'translateX(' + get_percent($ltabs) + '%)'
			});
		}
		
		function get_percent($ltabs) {
			var $items = $ltabs.find('.' + class_item);
			var $item_selected = $items.filter('.' + class_chosen);
			return 50 + (200 * ($item_selected.index() - 1));
		}
		
		function item_click() {
			var $this = jQuery(this);
			$this.siblings('.' + class_item).removeClass(class_chosen);
			$this.addClass(class_chosen);
			var $ltabs = get_container($this);
			move_percent($ltabs);
			$document.trigger($ltabs.data('event'), $this.data('value'));
		}
		
		function move_percent($ltabs) {
			get_track($ltabs).css({transform: 'translateX(' + get_percent($ltabs) + '%)'});
		}
		
		function get_tab_count($ltabs) {
			return $ltabs.find('.' + class_item).length;
		}
		
		function get_track($ltabs) {
			return $ltabs.find('.' + class_track);
		}
		
		function get_container(element) {
			return jQuery(element).closest('.' + class_container);
		}
		
		function get_selected($ltabs) {
			return $ltabs.find('.' + class_item).filter('.' + class_chosen);
		}
		
		function tab_swipe(e) {
			pub.move(get_container(e.target), e.type === 'swipeleft' ? 'right' : 'left');
		}
		
		pub.move = function($ltabs, direction) {
			var $item_selected = get_selected($ltabs);
			var $next = direction === 'left' ? $item_selected.prev() : $item_selected.next();
			if ($next.length) {
				$next.trigger('click');
			}
		};
		
		return pub;
		
	}(pub.ltabs));
	
	function load_search_filter (event) {
		yalwa.desktop.yli.start(jQuery(event.currentTarget));
		yalwa.basics.load_css(yalwa.basics.static_url('css') + '/desktop/sites/bsp/search_filter.css');
		yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/hammer.min.js').then(function() {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + '/desktop/search_filter.js');
		});
	}
	
	pub.yli = (function(pub) {
		
		pub = pub || {};
		
		pub.start = function($element, modifier) {
			$element.addClass('yli');
			if (modifier) {
				$element.addClass('yli--' + modifier);
			}
			setTimeout(() => {
				$element.addClass('yli--active');
			}, 200);
		};
		
		pub.stop = function($element, all) {
			if (all) {
				if (!$element[0]) {
					return;
				}
				const classes = $element[0].className.split(' ');
				for (let i = 0; i < classes.length; i++) {
					if (classes[i].indexOf('yli--') !== -1) {
						$element.removeClass(classes[i]);
					}
				}
			}
			$element.removeClass('yli yli--active');
		};
		
		pub.toggle = function($element, modifier) {
			if ($element.hasClass('yli--active')) {
				pub.stop($element);
			} else {
				pub.start($element, modifier);
			}
		};
		
		pub.progress = function($element, milliseconds, callback) {
			let $yli_progress = jQuery('<div class="js-yli_progress yli_progress"></div>');
			let color_darkened = $element.css('backgroundColor');
			color_darkened = '#000000';
			$yli_progress.css({backgroundColor: color_darkened});
			$element.addClass('yli_progress_parent').append($yli_progress);
			$yli_progress.velocity({width: '100%'}, {duration: milliseconds, complete: function() {
					if (typeof(callback) === 'function') {
						callback();
					}
					$yli_progress.remove();
					$element.removeClass('yli_progress_parent');
				}});
		};
		
		pub.progress_percentage = function($element, percent, callback) {
			const color_darkened = '#000000';
			if (!$element.find('.js-yli_progress').length) {
				const $yli_progress =  jQuery('<div class="js-yli_progress yli_progress"></div>');
				$yli_progress.css({backgroundColor: color_darkened});
				$element.addClass('yli_progress_parent').append($yli_progress);
			}
			const $progress_bar = $element.find('.js-yli_progress');
			jQuery.Velocity.hook($progress_bar, 'width', $progress_bar.width());
			$progress_bar.velocity(
				{
					width: percent_to_pixel(percent, $element.width())
				},
				{
					complete: function() {
						if (typeof(callback) === 'function') {
							callback();
						}
						if (percent === 100) {
							$progress_bar.remove();
							$element.removeClass('yli_progress_parent');
						}
					}
				}
			);
		};
		
		function percent_to_pixel(percent, element_width) {
			return (parseFloat(percent) && parseFloat(element_width)) ? element_width / 100 * percent : 0;
		}
		
		return pub;
		
	}(pub.yli));
	
	pub.ali = (function(pub) {
		pub = pub || {};
		
		var bem = 'ali';
		
		pub.init = function() {
			const $elements = jQuery('.js-ali_input');
			$elements.not('.js-ali_init_done')
				.on('focus', on_focus)
				.on('blur input change', on_blur);
			
			// solves chrome's credential autofill issue
			// setTimeout again???
			// actual only way to detect credential autofill is detecting -webkit-autofill css property on input.
			// IntersectionObserver fails: visibility do not change during browser adding the property to input. randomly true or false
			// MutationObserver fails; there is no mutations
			// waiting 100ms solves problem 99%
			setTimeout(function() {
				$elements
					.each(on_blur)
					.addClass('js-ali_init_done');
			},100);
		};
		
		pub.set_to_readonly =  function($element) {
			const $container = $element.closest('.js-ali');
			$element.attr('readonly', true);
			$container.addClass(bem + '--readonly');
			yalwa.basics.show($container.find('.yicon'));
			if (!$container.find('.yicon').length) {
				const $lock_icon = yalwa.basics.yicon('lock_closed');
				$container.append($lock_icon);
			}
			
			$element.blur();
		};
		
		function on_focus() {
			jQuery(this).closest('.js-ali').addClass(bem + '--infocus');
		}
		
		function on_blur() {
			const $this = jQuery(this);
			if (
				$this.is(":-webkit-autofill") ||
				$this.val() ||
				($this.prop('type') === 'date' && !yalwa.v.is_ios)
			) {
				on_focus.apply(this);
			} else {
				$this.closest('.js-ali').removeClass(bem + '--infocus');
			}
		}
		
		return pub;
	}(pub.ali));
	
	pub.check_for_detach = function() {
		jQuery('.js-detach_body').each(detach_body);
	};
	
	function detach_body() {
		var $this = jQuery(this);
		if ($this.data('detach_to')) {
			$this.detach().removeClass('js-detach_body').appendTo(jQuery($this.data('detach_to')));
		} else {
			$this.detach().removeClass('js-detach_body').appendTo(jQuery('body'));
		}
	}
	
	function ip_hint_close() {
		const $this = jQuery(this).closest('.js-ip_hint,.js-ip_hint_city');
		yalwa.basics.set_cookie($this.hasClass('js-ip_hint_city') ? 'no_redirect_hint_ahp' : 'no_ip_redirect_hint', true, 86400*30);
		jQuery('#hint_box').remove();
	}
	
	function init_public_profile() {
		jQuery('.close_modal').click(function() {
			jQuery('.mymodal').fadeOut();
		});
		jQuery('#imprint_link').on('click', function() {
			jQuery('.mymodal').fadeIn();
		});
	}
	
	function init_back_to_top() {
		jQuery('.back_to_top').fadeIn();
		jQuery('.back_to_top').off('click').on('click', function() {
			if (yalwa.basics.is_mobile_site()) {
				jQuery('.main_col').scrollTop(0);
			} else {
				jQuery("html, body").animate({scrollTop: 0}, "slow");
			}
		});
	}
	
	function check_read_only() {
		if (!yalwa.v.read_only_announcement) {
			return;
		}
		if (yalwa.basics.ss_get('hide_announcement')) {
			return;
		}
		var div = jQuery('<div id="announcement_box" />')
			.addClass('announcement')
			.html(' ' + yalwa.v.read_only_announcement)
			.prepend(jQuery('<img src="/images/16/sign_warning.png" align="absmiddle"/>'))
			.hide();
		
		jQuery('<img src="/images/16/close.png" />').css({
			cursor: 'pointer',
			position: 'absolute',
			right: '8px',
			top: '7px'
		}).click(function() {
			yalwa.basics.ss_set('hide_announcement', true);
			jQuery('#announcement_box').remove();
		}).appendTo(div);
		
		div.prependTo(jQuery('body'));
		
		div.slideDown();
	}
	
	pub.nlp = (function(pub) {
		pub = pub || {};
		pub.initalized = false;
		pub.init = function() {
			if (pub.initalized) {
				return;
			}
			pub.initalized = true;
			if ("performance" in window){
				window.addEventListener("load", ()=>{
					prepare_category_names();
				});
			}
		}
		function prepare_category_names() {
			if (yalwa.v.is_nlp) {
				let title_height = 0;
				let $category_titles = jQuery('.js-nlp_title');
				$category_titles.each(function() {
					title_height = title_height < jQuery(this).height() ? jQuery(this).height() : title_height;
				})
				$category_titles.height(title_height)
			}
		}
		
		return pub;
		
	}(pub.nlp));
	
	function init_nickname_blur() {
		var is_account_page = (typeof yalwa.accounts !== 'undefined');
		jQuery('#nickname').on('keypress', function(event) {
			if (event.keyCode === 10 || event.keyCode === 13) {
				jQuery('#nickname').trigger('blur');
				window.setTimeout(function() {
					jQuery('#submit').trigger('click');
				}, 400)
			}
		})
			.on('blur', function() {
				jQuery('body').addClass('wait');
				window.setTimeout(function() {
					jQuery('body').removeClass('wait');
				}, 500);
				
				var countryID = jQuery(this).data('countryid');
				if (is_account_page) {
					yalwa.accounts.submit_button.prop('disabled', true);
				}
				jQuery.post(
					'/api/ajax/nickname_check/',
					{
						nickname: jQuery('#nickname').val()
					},
					function(response) {
						jQuery('#nickname_info').hide();
						if (response[0] == true) {
							if (is_account_page) {
								yalwa.accounts.submit_button.prop('disabled', false);
							}
							jQuery('#nickname_info').text('');
						} else {
							var info = response[1];
							if (!info) {
								return;
							}
							if (response[2] == 'has_illegal_chars') {
								var badChar = jQuery('#nickname').val().match(/[^A-Za-z0-9-_àáâäœæçéèêëîïíñoöôóùúûüÿÄÖÜ]/);
								info += ': ' + badChar;
							}
							
							jQuery('#nickname_info').html(info).show();
							
							if (response[2] == 'suggestions') {
								jQuery('#nickname_info').append(' ' + response[3] + ' ');
								var suggestions = response[4];
								var first = true;
								var a;
								for (var i in suggestions) {
									if (first) {
										first = false;
									} else {
										jQuery('#nickname_info').append(', ');
									}
									a = jQuery('<a href="#">' + suggestions[i] + '</a>');
									a.on('click', function() {
										jQuery('#nickname').val(jQuery(this).text());
										if (is_account_page) {
											yalwa.accounts.submit_button.prop('disabled', false);
										}
										jQuery('#nickname_info').text('').hide();
										return false;
									});
									
									jQuery('#nickname_info').append(a);
								}
							}
						}
					},
					'json'
				);
			});
	}
	
	function check_paf_started() {
		if (!yalwa.basics.is_logged_in()) {
			jQuery('.js-paf_started_reminder').remove();
			return;
		}
		var ts = yalwa.basics.get_cookie('paf_started');
		if (!ts || yalwa.v.upid_key !== 'locanto') {
			jQuery('.js-paf_started_reminder').remove();
			return;
		}
		var diff_seconds = yalwa.basics.unix() - ts;
		if (diff_seconds > (10 * 60) && jQuery('.js-paf_started_reminder').length) {
			yalwa.basics.show(jQuery('.js-paf_started_reminder'));
			head.ready('velocity.including.ui.min.js', function() {
				setTimeout(function() {
					jQuery('.js-paf_started_reminder').velocity('callout.pulse');
				}, 2000);
			});
			jQuery('.js-paf_started_reminder').on('click', function(e) {
				yalwa.basics.set_cookie('paf_started', 0, -1);
				var url = yalwa.basics.get_cookie('paf_started_url');
				if (url) {
					yalwa.basics.navigate(url);
					e.preventDefault();
					e.stopPropagation();
				}
			})
		} else {
			jQuery('.js-paf_started_reminder').remove();
		}
	}
	
	function check_routing() {
		yalwa.basics.check_routing();
		var routing = yalwa.basics.get_routing();
		switch (routing) {
			case 'mail_unsubscribe':
				jQuery('.js-delete_account_go').on('click', function() {
					jQuery('#main').addClass('blured');
					jQuery('#delete_account_confirm').fadeIn();
				});
				jQuery('.js-delete_account_warning').on('click', function() {
					jQuery('.js-delete_account_submit').trigger('click');
				});
				break;
			case 'PAF':
			case 'PAF_create_new':
				//paf_start GA metric
				if (!yalwa.v.manage_ad && !yalwa.basics.ss_get('paf_start_tracked')) {
					yalwa.basics.ga.ping_metric('CM_PAF_START', 1);
					yalwa.basics.ss_set('paf_start_tracked', true);
				}
				break;
			case 'youth_protection':
				jQuery('.js-underage_accept').on('click', function(event) {
					event.preventDefault();
					yalwa.basics.set_cookie('loc_underage_accept', 1, 2592000);
					window.location.href = event.target.href;
					return false;
				});
				break;
			case 'followers':
				yalwa.desktop.ltabs.init();
				yalwa.basics.init_followers_tabs();
				followers_pagination_init();
				break;
		}
	}
	
	function init_container_click_propagation() {
		jQuery('.js-container_click_propagation').on('click', function(e) {
			if (e.target.nodeName !== 'A') {
				var $a = jQuery(this).find('a');
				if ($a.attr('target') === '_blank') {
					yalwa.basics.new_tab($a.attr('href'));
				} else {
					yalwa.basics.navigate($a.attr('href'));
				}
			}
		});
	}
	
	function check_ie_scroll_jank_fix() {
		// https://coderwall.com/p/hlqqia/ie-fix-for-jumpy-fixed-bacground
		// hopefully fixed my MS soon, check from time to time..
		if (navigator.userAgent.match(/Trident\/|Edge\//)) {
			document.body.addEventListener('mousewheel', function(e) {
				e.preventDefault();
				window.scrollTo(0, window.pageYOffset - e.wheelDelta);
			});
		}
	}
	
	function init_delete_location_button() {
		// Hide the button at the start
		if (jQuery('.js-geo_search_topnav').val() == '') {
			yalwa.basics.hide(jQuery('.js-delete_location_button'));
		}
		
		jQuery('body')
			.on('keyup', '.js-geo_search_topnav', empty_geo_search_field)
			.on('click', '.js-delete_location_button', set_nationwide_url);
	}
	
	/**
	 * Hide the "remove location" button when the location name fiel is empty
	 */
	function empty_geo_search_field() {
		var $location_button = jQuery('.js-delete_location_button');
		
		if (jQuery(this).val() === '') {
			yalwa.basics.hide($location_button);
		} else {
			yalwa.basics.show($location_button);
		}
	}
	
	/**
	 * Set the Url of the submit form to a nationwide url
	 */
	function set_nationwide_url() {
		var nationwide_url = jQuery(this).data('nationwide_url');
		
		if (nationwide_url && nationwide_url.length > 3) {
			// Replace the url on the form with the nationwide version
			jQuery(this).closest('form').attr('action', nationwide_url);
			jQuery('.js-geo_search_topnav').val('').data('geoid', '').focus();
			jQuery('.search.button').velocity('callout.pulse');
		}
		yalwa.basics.hide(jQuery('.js-delete_location_button'));
	}
	
	function setup_login() {
		if (yalwa.basics.is_logged_in()) {
			const address = decodeURIComponent(yalwa.basics.get_cookie(yalwa.v.logged_in_cookie_name));
			if (jQuery('#logged_in_address_field').length > 0) {
				jQuery('#logged_in_address_field').html('<strong>' + address.replace(/\+/g, ' ') + '</strong> |').show();
			}
			
			if (jQuery('.js-logged_in_logout_field').length > 0) {
				let logout_link = yalwa.v.accounts_url + 'logout';
				logout_link = jQuery('<a class="js-logout" rel="nofollow" href="' + logout_link + '">' + yalwa.v.lang.logout + '</a>');
				jQuery('.js-logged_in_logout_field').html(logout_link).show();
			}
			
			jQuery('<a rel="nofollow" title="" href="' + yalwa.v.account_section_url + '?show=inbox" class="hidden js-mc_notifier mc_notifier">' + yalwa.basics.yif('user_message') + '</a>')
				.prependTo(jQuery('#logged_in_address_field'));
			// get status of inbox
			update_mc_counter();
			jQuery('#welcome_box').hide();
			jQuery('#navigation_box').fadeTo('slow', 1);
		} else {
			let login_link = yalwa.v.accounts_url + 'login';
			const tp = yalwa.basics.auth.touchpoint_parameter() + '=1';
			if (yalwa.v.myUrl) {
				login_link += '?continue=' + encodeURI(yalwa.v.myUrl) + '&' + tp;
			} else {
				login_link += '?' + tp;
			}
			login_link = jQuery('<a rel="nofollow" class="js-headroom_login_button" href="' + login_link + '">' + yalwa.v.lang.login_register + '</a>');
			jQuery('.js-logged_in_logout_field').html(login_link).show();
			jQuery('#welcome_box').fadeTo('slow', 1);
		}
	}
	
	function update_mc_counter() {
		jQuery.get(
			'/api/ajax/get_inbox',
			{},
			function(response) {
				jQuery('.js-mc_notifier').attr('title', response.title + ' (' + response.unread + ')')
				yalwa.basics.toggle(jQuery('.js-mc_notifier'), response.success && response.unread > 0);
				window.setTimeout(update_mc_counter, 120000);
			},
			'json'
		);
	}
	
	pub.init_tooltips = function() {
		jQuery('.tooltip').each(function() {
			var $this = jQuery(this);
			$this.data('title', $this.attr('title'));
		}).off('mouseover').on('mouseover', function() {
			tooltip.show(jQuery(this).data('title'));
		}).off('mouseout').on('mouseout', function() {
			tooltip.hide();
		}).removeAttr('title').removeClass('tooltip');
	};
	
	function init_fixed_metas_affix() {
		jQuery('body').on('mouseover', function() {
			yalwa.basics.hide(jQuery('#fixed-logo-metas'));
		});
		
		jQuery('#fixed-logo-metas').on('mouseover', function(evt) {
			evt.stopPropagation();
		});
		
		jQuery('.logo_link').on('mouseover', function(evt) {
			evt.stopPropagation();
			evt.preventDefault();
			yalwa.basics.show(jQuery('#fixed-logo-metas'));
			
		});
	}
	
	function navigation_affix() {
		var threshold = 50;
		
		switch (yalwa.v.page_type) {
			case 'MYLOCANTO':
				threshold = 75;
				break;
			case 'INDEX':
			case 'HOME':
				if (yalwa.v.new_bp) {
					threshold = 230;
				}
				break;
			case 'SEARCH':
			case 'BROWSE':
				if (yalwa.v.new_bp) {
					threshold = 140;
				}
		}
		if (jQuery('#tabs').length > 0) {
			threshold = jQuery('#tabs').offset().top;
		} else if (jQuery('#search_form').length > 0) {
			threshold = jQuery('#search_form').offset().top;
		}
		
		var extra_tracking = false;
		var $header_Link_box = jQuery('.js-header_top_menu');
		//var $tabs = jQuery('#tabs');
		var $is_menu_fixed = false;
		var $settings_icon = '<i class="yif yif_16 flaticon_desktop flaticon-gear header_link_box_fixed__settings_icon"></i>';
		
		jQuery(document).on('ready scroll', function() {
			var y = $(this).scrollTop();
			if (y > threshold) {
				
				jQuery('#top-bar').css('display', 'block');
				if (!$is_menu_fixed) {
					$header_Link_box.clone().appendTo('#top-bar .js-top_bar').removeClass('header_link_box').addClass('header_link_box_fixed').find('#width_check').remove();
					
					// initialize login/register handlers on cloned HTML
					yalwa.basics.auth.init();
					
					if (jQuery('.as_fixed_nav').html()) {
						jQuery('.header_link_box_fixed .main>a').html($settings_icon);
						jQuery('.post-ad-button-sm span').addClass('post-ad-button-sm__my_span');
						jQuery('.post-ad-button-sm').addClass('post-ad-button-sm__my');
					}
					
					$is_menu_fixed = true;
				}
				//jQuery('#tabs').hide();
				
				if ((typeof yalwa.v.skip_fixed_searchbar === 'undefined' || yalwa.v.skip_fixed_searchbar === false) && yalwa.v.navigation_affix_searchbar && jQuery('.js-searchbox_new').html()) {
					
					jQuery('.tabs_fixed').hide();
					jQuery('#last_searches').hide();
					jQuery('.js-search_suggestions').hide();
					var searchbar_html = jQuery('.js-searchbox_new').html();
					jQuery('.js-fixed_searchbar').html(searchbar_html);
					jQuery('.js-searchbox_new').html('');
					if (yalwa.geosearch) {
						yalwa.geosearch.searchbox('js-fixed_searchbar');
					}
					
					if (yalwa.v.load_last_searches) {
						init_last_searches();
					}
					if (yalwa.v.upid_key === 'locanto') {
						init_search_suggestions();
					}
					if (!extra_tracking) {
						jQuery('.search.button').on('click.affix', function() {
							yalwa.basics.ga.event({category: 'Search from fixed navigation'});
						});
						extra_tracking = true;
					}
				}
			} else {
				
				jQuery('#tabs').show();
				jQuery('#top-bar').css('display', 'none');
				//jQuery('.header_link_box').removeClass('link-box-fixed');
				if ((typeof yalwa.v.skip_fixed_searchbar === 'undefined' || yalwa.v.skip_fixed_searchbar === false) && yalwa.v.navigation_affix_searchbar && jQuery('.js-fixed_searchbar').html()) {
					
					jQuery('#last_searches').hide();
					jQuery('.js-search_suggestions').hide();
					var searchbar_html = jQuery('.js-fixed_searchbar').html();
					jQuery('.js-searchbox_new').html(searchbar_html);
					jQuery('.js-fixed_searchbar').html('');
					if (yalwa.geosearch) {
						yalwa.geosearch.searchbox('topnav');
					}
					
					if (yalwa.v.load_last_searches) {
						init_last_searches();
					}
					
					if (yalwa.v.upid_key === 'locanto') {
						init_search_suggestions();
					}
					
					if (extra_tracking) {
						jQuery('.search.button').unbind('click.affix');
						extra_tracking = false;
					}
					
				}
				
			}
		});
	}
	
	function init_search_suggestions() {
		
		jQuery('.js-topnav-search').on('search', function() {
			// this function will be executed on click of X (clear button)
			if (jQuery(this).val()) {
				return;
			}
			jQuery('#last_searches').show();
			jQuery('.js-search_suggestions').hide();
			yalwa.v.suggested_search = false;
		})
			.on('keyup', function(e) {
				if ((e.which >= 37 && e.which <= 40) || e.which == 13) {
					return true;
				}
				var keyword = jQuery(this).val();
				if (!keyword || keyword.length < 3) {
					jQuery('#last_searches').show();
					jQuery('.js-search_suggestions').hide();
					yalwa.v.suggested_search = false;
				} else {
					
					if (yalwa.v.search_suggested_L1) {
						var L1 = yalwa.v.search_suggested_L1;
					} else {
						var L1 = 0;
					}
					
					if (yalwa.v.search_suggested_L2) {
						var L2 = yalwa.v.search_suggested_L2;
					} else {
						var L2 = 0;
					}
					
					if (yalwa.v.search_suggested_L3) {
						var L3 = yalwa.v.search_suggested_L3;
					} else {
						var L3 = 0;
					}
					
					jQuery.get('/api/ajax/search_autocomplete',
						{
							keyword: keyword,
							L1: L1,
							L2: L2,
							L3: L3,
							current_geoID: yalwa.v.current_geoID
						}, function(json_data) {
							var data = jQuery.parseJSON(json_data);
							jQuery('.js-suggestions_search_list').html('');
							var empty = true;
							jQuery.each(data, function(key, popsearch) {
								empty = false;
								var html = '<li>';
								
								if (popsearch.type == 'popular_search') {
									html += '<a href="' + popsearch.popsearch_url + '" data-type="popular_search">';
									html += '<table><tr><td>' + popsearch.l1_icon + '</td>';
									html += '<td>' + popsearch.suggested_keyword + '</span></td>'
								} else if (popsearch.type == 'category') {
									html += '<a href="' + popsearch.url + '" data-type="category">';
									html += '<table><tr><td>' + popsearch.l1_icon + '</td>';
									html += '<td>' + popsearch.suggested_l3 + '</td>'
								} else if (popsearch.type == 'default_search') {
									html += '<a data-type="submit" href="' + popsearch.url + '" data-type="category">';
									html += '<table><tr><td>' + popsearch.l1_icon + '</td>';
									html += '<td>' + popsearch.suggested_keyword + '</td>'
								}
								
								html += '</tr></table></a></li>';
								
								jQuery('.js-suggestions_search_list').append(html);
							});
							
							if (empty) {
								yalwa.v.suggested_search = false;
								jQuery('.js-search_suggestions').hide();
							} else {
								yalwa.v.suggested_search = true;
								jQuery('.js-search_suggestions').show();
								
								var $selected_li = jQuery('.js-suggestions_search_list li').first();
								$selected_li.addClass('selected');
								var $all_li = jQuery('.js-suggestions_search_list li');
								
								$all_li.on('mouseenter', function() {
									$all_li.removeClass('selected');
									$selected_li = jQuery(this);
									$selected_li.addClass('selected');
								});
								
								jQuery('.js-suggestions_search_list li a[data-type="submit"]').on('click', function(e) {
									e.preventDefault();
									jQuery('.search.button').trigger('click');
									
								});
								
								$('.js-topnav-search').unbind('keydown').on('keydown', function(e) {
									switch (e.which) {
										
										case 13: // enter
											if ($selected_li.find('a').data('type') == 'submit') {
												jQuery('.search.button').trigger('click');
											} else {
												e.preventDefault();
												window.location = $selected_li.find('a').attr('href');
												
											}
											
											break;
										
										case 38: // up
											$all_li.removeClass('selected');
											if ($selected_li.prev().length) {
												$selected_li = $selected_li.prev();
											} else {
												$selected_li = $all_li.last();
											}
											$selected_li.addClass('selected');
											e.preventDefault();
											break;
										
										case 40: // down
											$all_li.removeClass('selected');
											if ($selected_li.next().length) {
												$selected_li = $selected_li.next();
											} else {
												$selected_li = $all_li.first();
											}
											
											$selected_li.addClass('selected');
											e.preventDefault();
											break;
										
										default:
											return; // exit this handler for other keys
									}
									
								});
							}
						}
					);
					
					jQuery('#last_searches').hide();
					
				}
			})
			.on('focusout', function(event) {
				jQuery('.js-search_suggestions').fadeOut();
			});
	}
	
	function handle_search_button() {
		var $location = jQuery('.js-geo_search_topnav');
		var $search = jQuery('.js-topnav-search');
		var $button = jQuery('.js-search_form_btn');
		
		if (($location.val() && $location.data('geoid')) || $search.val()) {
			$button.prop('disabled', false);
		} else {
			$button.prop('disabled', true);
		}
	}
	
	function followers_pagination_init() {
		
		jQuery('.js-followers_list__pagination_button').on('click', function(event) {
			let state = jQuery(this).closest('.js-followers_list__pagination');
			let type = state.data('type');
			let current_page = state.data('current-page');
			let pages_count = state.data('pages');
			let direction = jQuery(this).data('direction');
			if (direction === 'next') {
				if (current_page < pages_count) {
					jQuery.post(
						'/api/ajax/followers_list',
						{
							action: type,
							page: current_page + 1
						},
						function(data) {
							if (data.success) {
								jQuery('.js-'+type+'_list').html(data.html);
								state.data('current-page',current_page + 1);
								jQuery('.js-'+type+'_list_current_page').html(state.data('current-page'));
							}
						},
						'json'
					);
				}
			}
			if (direction === 'prev') {
				if (current_page > 1) {
					jQuery.post(
						'/api/ajax/followers_list',
						{
							action: type,
							page: current_page - 1
						},
						function(data) {
							if (data.success) {
								jQuery('.js-'+type+'_list').html(data.html);
								state.data('current-page',current_page - 1);
								jQuery('.js-'+type+'_list_current_page').html(state.data('current-page'));
							}
						},
						'json'
					);
				}
			}
		});
	
	}
	
	function init_last_searches() {
		jQuery('#last_search_btn').on('click', function(event) {
			event.stopPropagation();
			jQuery('#last_searches').fadeToggle();
		});
		
		jQuery('.js_lastsearch-topnav').on('click', function(event) {
			event.stopPropagation();
		});
		
		jQuery('body')
			.on('focusin', '.js-topnav-search', function(event) {
				if (yalwa.v.suggested_search) {
					jQuery('.js-search_suggestions').show();
				} else {
					jQuery('#last_searches').show();
				}
			})
			.on('focusout', '.js-topnav-search', function(event) {
				event.stopPropagation();
				jQuery('#last_searches').fadeOut();
			})
			.on('blur', '.js-topnav-search', function(event) {
				handle_search_button();
			});
		
		jQuery('.last_searches_content a .flaticon-remove_thin').on('click', function(event) {
			jQuery('#last_searches').fadeOut();
			event.stopPropagation();
			jQuery('.js-topnav-search').focus();
			var $element = jQuery(this);
			$element.parents('li').remove();
			
			const last_searches = JSON.parse(decodeURIComponent(yalwa.basics.get_cookie('last_searches')));
			
			const cookie_after_removal = last_searches.filter(item => !(
				item.countryID == $element.data('countryid')
				&& item.areaID == $element.data('areaid')
				&& item.geoID == $element.data('geoid')
				&& item.L1 == $element.data('l1')
				&& item.L2 == $element.data('l2')
				&& item.L3 == $element.data('l3')
				&& item.language == $element.data('language')
				&& item.query == $element.data('query')
			));
			
			yalwa.basics.set_cookie('last_searches', encodeURIComponent(JSON.stringify(cookie_after_removal)), 86400 * 30);
			
			return false;
		});
	}
	
	pub.is_mobile_device = function(string) {
		return is_mobile_device(string);
	};
	
	pub.open_user_online_pa_promo_click = function(e) {
		e.preventDefault();
		jQuery('#main').addClass('blured');
		jQuery('#vap_pa_promo_useronline_popup').fadeIn();
	};
	
	pub.generic_shadow = (function(pub) {
		pub = pub || {};
		
		let defaults = {
			'background': 'hsla(0, 0%, 0%, 0.7)',
			'zindex': '9999',
			'onclick': function() {
				if (jQuery('.js-plp_modal:visible').length) {
					return;
				}
				if (jQuery(".js-plp_ok").filter(':visible').length > 0) {
					jQuery(".js-plp_ok").filter(':visible').trigger( "click" );
				} else if (jQuery(".js-plp_close").filter(':visible').length > 0) {
					jQuery(".js-plp_close").filter(':visible').trigger( "click" );
				}
			},
			'callback': null
		};
		let $gs = null;
		
		pub.init = function() {
			$gs = jQuery('.js-generic_shadow');
			jQuery.Velocity.hook($gs, 'translateX', '-50%');
		};
		
		pub.show = function(overwrites) {
			let options = jQuery.extend(defaults, overwrites);
			$gs.off('click').css({'z-index': options.zindex,'background': options.background});
			let velocity_options = {
				duration: options.duration || 150
			};
			if (options.callback) {
				velocity_options.complete = options.callback;
			}
			
			if ($gs.hasClass('hidden')) {
				yalwa.basics.show($gs).velocity('fadeIn', velocity_options);
			}
			yalwa.basics.show($gs);
			if (options.onclick) {
				$gs.on('click' + (options.namespace ? ('.' + options.namespace) : ''), options.onclick);
			}
			if (yalwa.v.is_ios) {
				$gs.on('touchmove', ios_prevent_background_scrolling);
			}
			jQuery('html').addClass('generic_shadow_activated');
		};
		
		pub.hide = function(no_animation) {
			const deferred = jQuery.Deferred();
			$gs.velocity('fadeOut', {
				duration: no_animation === true ? 0 : 150,
				complete: function() {
					yalwa.basics.hide($gs);
					jQuery('html').removeClass('generic_shadow_activated');
					deferred.resolve();
				}
			});
			return deferred;
		};
		
		return pub;
		
	}(pub.generic_shadow));
	
	pub.del_last_visited = function del_ad(id) {
		jQuery.ajax({
			method: 'get',
			url: '/api/ajax/last_visited_ads_delete/',
			data: {
				id: id
			},
			success: function(response) {
				if (response) {
					if (response == -1) {
						jQuery('#last_visited_ads').remove();
						jQuery('#bottom').css('border-top', '1px solid #ccc');
					} else {
						jQuery('#last_visited_' + response).remove();
					}
				}
			}
		});
	};
	
	//check if user came from back button
	pub.is_loaded_via_back_or_forward = function() {
		if (window.performance && typeof(window.performance.getEntriesByType) === "function") {
			const tmp = window.performance.getEntriesByType("navigation");
			if (tmp && tmp[0]) {
				return tmp[0].type === "back_forward";
			}
		}
		return false;
	};
	
	//toggle star if user came from back button
	pub.toggle_after_back_button = function(isBackButton, toggleStar){
		if (isBackButton) {
			jQuery.ajax({
				type: 'post',
				url: '/api/favorites/get/',
				dataType: 'json'
			}).done((response) => {
				yalwa.v.favorites = response;
			}).done(toggleStar);
		} else {
			toggleStar();
		}
	};
	
	function init_disabled_searchbtn_nosearch() {
		var $location = jQuery('.js-geo_search_topnav');
		var $search = jQuery('.js-topnav-search');
		var $button = jQuery('.js-search_form_btn');
		
		if ($location.val() || $search.val()) {
			$button.prop('disabled', false);
		} else {
			$button.prop('disabled', true);
		}
		toggle_search_button_status($location, $search, $location, $button, 'keyup', true);
		toggle_search_button_status($search, $search, $location, $button, 'keyup', true);
	}
	
	function toggle_search_button_status($add_event_here, $search_input, $location_input, $button, event_name) {
		$add_event_here.on(event_name, function() {
			if ($location_input.val() || $search_input.val()) {
				$button.prop('disabled', false);
			} else {
				$button.prop('disabled', true);
			}
		});
	}
	
	function init_magic_link_tracking() {
		if (jQuery('.js-ml_email_sent').length > 0) {
			yalwa.basics.ga.event({
				category: 'magic_link',
				action: 'impression',
				label: 'email_sent'
			});
		}
	}
	
	pub.magic_link = (function(pub) {
		pub = pub || {};
		
		let error_labels = [];
		
		pub.init = function(labels) {
			error_labels = labels;
			jQuery(document).on('ltabs_login', function() {
				toggle_to_login_form();
			});
			yalwa.desktop.magic_link.init_btns();
		};
		
		pub.init_btns = function() {
			jQuery('.js-ajax_magic_link_start').on('click', () => {
				yalwa.desktop.magic_link.toggle_to_ml_form();
			});
			jQuery('.js-magic_link_back_link').on('click', () => {
				toggle_to_login_form();
			});
			jQuery('.js-ajax_ml_submit').on('click', () => {
				request_magic_link();
			});
			jQuery('.js_ml_request_form').on('submit', (e) => {
				e.preventDefault();
				request_magic_link();
			});
		};
		
		pub.toggle_to_ml_form = function() {
			reset_ml_form();
			if (jQuery('.js-login_id').val().length !== 0) {
				jQuery('.js-login_id_ml').val(jQuery('.js-login_id').val());
				jQuery('.js-login_id_ml_ali').addClass('ali--infocus');
			}
			yalwa.basics.hide(jQuery('.js-login_section_form'));
			yalwa.basics.show(jQuery('.js-magic_link_section'));
		};
		
		function toggle_to_login_form() {
			yalwa.basics.hide(jQuery('.js-magic_link_section'));
			yalwa.basics.show(jQuery('.js-login_section_form'));
		};
		
		function request_magic_link() {
			let email = jQuery('.js-login_id_ml').val();
			if (email.length > 0) {
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'account',
					action: 'magiclink',
					data: {
						email: email
					}
				}).then((response) => {
					if (response.success === true) {
						show_notice('email_sent', email);
					} else {
						show_notice(response.error, response.time_to_wait);
					}
				});
			} else {
				show_notice('invalid_email');
			}
		}
		
		function show_notice(error_name, value = '') {
			if (!error_name) {
				return false;
			}
			yalwa.basics.hide(jQuery('.js-ml_intro_text'));
			switch (error_name) {
				case 'invalid_email':
					reset_ml_form();
					yalwa.basics.toast({message: error_labels.ml_error_invalid, type: 'error'});
					break;
				case 'wait_time':
					reset_ml_form();
					let minutes = Math.floor(value / 60);
					let seconds = String(Math.round(value % 60)).padStart(2, '0');
					yalwa.basics.toast({message: error_labels.ml_error_time.replace('%1$s', minutes).replace('%2$s', seconds), type: 'error'});
					break;
				case 'email_sent':
					reset_ml_form(true);
					let new_label_val = jQuery('.js-email_sent_text').html().replace('%1$s', value);
					jQuery('.js-email_sent_text').html(new_label_val);
					yalwa.basics.hide(jQuery('.js-login_id_ml'))
					yalwa.basics.hide(jQuery('.js-login_id_ml_ali'))
					yalwa.basics.hide(jQuery('.js-ajax_ml_submit'))
					yalwa.basics.show(jQuery('.js-email_sent'));
					break;
			}
		}
		
		function reset_ml_form(only_hide = false) {
			jQuery('.js-login_id_ml_ali').removeClass('ali--infocus');
			jQuery('.js-login_id_ml').val('');
			yalwa.basics.hide(jQuery('.js-email_sent'));
			yalwa.basics.show(jQuery('.js-login_id_ml'));
			yalwa.basics.show(jQuery('.js-login_id_ml_ali'));
			if (!only_hide) {
				yalwa.basics.show(jQuery('.js-ml_intro_text'));
				yalwa.basics.show(jQuery('.js-ajax_ml_submit'));
			}
		}
		
		return pub;
	}(pub.magic_link));

	return pub;
	
}(yalwa.desktop));

yalwa.basics.init_wrapper(yalwa.desktop.init, 'jquery.min.js');
